import { Fragment, useState } from 'react';
import { Trans } from '@lingui/react/macro';
import { IconButton, Menu } from '@pocketlaw/tetris';
import { Falcon } from '@pocketlaw/tetris/macro';
import { DeleteDraftDialog } from './DeleteDraftDialog';
export function DraftActionMenu(props) {
    const { cacheId, entityId, typename } = props;
    const [openDeleteDialog, setOpenDeleteDialog] = useState(false);
    const showDeleteDialog = () => {
        setOpenDeleteDialog(true);
    };
    const hideDeleteDialog = () => {
        setOpenDeleteDialog(false);
    };
    return (<Fragment>
      <Menu.Root target={<IconButton appearance="ghost" size="xs">
            <Falcon icon="ellipsis-h"/>
          </IconButton>}>
        <Menu.Item onClick={showDeleteDialog}>
          <Trans comment="Search Table Row Context Menu item - Delete">Delete</Trans>
        </Menu.Item>
      </Menu.Root>

      {openDeleteDialog && (<DeleteDraftDialog cacheId={cacheId} entityId={entityId} typename={typename} onClose={hideDeleteDialog}/>)}
    </Fragment>);
}
